import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Dimmer, Loader} from 'semantic-ui-react';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import OrderDetail from './orderDetail';

class InternalOrderTable extends Component {
  renderActionsColumnTitle() {
    if (!hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.Delete)) {
      return null;
    }
    return <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>;
  }

  renderTable() {
    return (
      <div>
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Cod Parte</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad Requerida</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad Disponible</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Precio de venta</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Subtotal</Table.HeaderCell>
              {this.renderActionsColumnTitle()}
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <OrderDetail />
          </Table.Body>
        </Table>
      </div>
    );
  }

  getTextForLoader() {
    const {savingLineInfo, deleting} = this.props;
    if (savingLineInfo) {
      return 'Guardando';
    }
    if (deleting) {
      return 'Eliminando';
    }
    return 'Cargando';
  }

  renderLoader() {
    const {loadingClients, loadingWarehouses, savingLineInfo, deleting} = this.props;
    const isDisabled = loadingClients || loadingWarehouses || savingLineInfo || deleting;
    if (!isDisabled) {
      return null;
    }

    const textToShow = this.getTextForLoader();
    return (
      <Dimmer active inverted>
        <Loader inverted content={textToShow} />
      </Dimmer>
    );
  }

  render() {
    const {orderCode} = this.props;
    if (!orderCode) {
      return null;
    }

    return (
      <Card fluid raised>
        {this.renderLoader()}
        {this.renderTable()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  const internalOrderToEdit = state.internalOrder.internalOrderToEdit;

  return {
    'orderCode': internalOrderToEdit ? internalOrderToEdit.code : '',
    'loadingClients': state.dealer.loading,
    'loadingWarehouses': state.warehouses.loading,
    'savingLineInfo': state.internalOrder.creating,
    'deleting': state.internalOrder.deleting,
    'permissions': state.session.permissions,
  };
};


export default connect(mapStateToProps, {})(InternalOrderTable);
